import {createSlice} from '@reduxjs/toolkit';
import {httpPythonGet, httpPythonPost} from '../../util/Rest';

const initialData = {
  cliId: [],
  servId: {},
  rateTable: {},
  isLoadingView: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'EditRateTable',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoadingView = true;
      state.errorMsg = null;
    },
    getClients: (state, action) => {
      state.cliId = action.payload.data;
      state.isLoadingView = false;
      state.errorMsg = null;
    },
    getservices: (state, action) => {
      state.servId = action.payload.data;
      state.isLoadingView = false;
      state.errorMsg = null;
    },
    rateTableData: (state, action) => {
      state.rateTable = action.payload.data;
      state.isLoadingView = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoadingView = false;
      state.accountLegalStatus = null;
    },
    resetMsg: (state) => {
      state.isLoadingView = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchError, rateTableData, getservices, getClients} = slice.actions;


export const getClientIds = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonGet('/getList')
      .then((data) => {
        if (data && data.status && data.status === 200 && data.data.status !== 200) {
          dispatch(fetchError(data?.data?.error));
        } else if (data && data.status && data.status === 200) {
          dispatch(getClients(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getServiceIDs = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getList', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getservices(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const postRateTable = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPythonPost('/getRateTable', details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(rateTableData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


